import React, { InputHTMLAttributes } from 'react';

import { Container, InputGroup, Input, Toggle, Label } from './styles';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string | null;
}

const InputToggle: React.FC<Props> = (props) => {
  const handle_change = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange } = props;

    event.currentTarget.value = event.currentTarget.checked ? 'true' : 'false';

    if (onChange) {
      onChange(event);
    }
  };

  return (
    <Container>
      <InputGroup>
        <Input
          id={props.id}
          name={props.name}
          type='checkbox'
          onChange={handle_change}
          defaultChecked={props.defaultChecked}
        />
        <Toggle htmlFor={props.id} />
      </InputGroup>
      {props.label && <Label>{props.label}</Label>}
    </Container>
  );
};

export { InputToggle };
